import { AxiosService } from '@/shared/utils'
import { AxiosRequestConfig } from 'axios'
import { BrushMapReportType } from '@/shared/types'

class BrushReportApi extends AxiosService {
  constructor(config?: AxiosRequestConfig) {
    super(config)
  }

  public getReports(patientId: number) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/brush-maps/list',
      params: {
        patient_id: patientId,
      },
    })
  }

  public getReport(reportId: number) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/brush-maps/',
      params: {
        id: reportId,
      },
    })
  }

  public saveReport(patientId: number, report: BrushMapReportType) {
    const { brushesFirm, teeth, firstGroupColors, secondGroupColors } = report

    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/brush-maps/',
      data: {
        date_at: new Date(),
        brushesFirm: brushesFirm,
        teeth: teeth,
        firstGroupColors: firstGroupColors,
        secondGroupColors: secondGroupColors,
        patient_id: patientId,
      },
    })
  }

  public updateReport(reportId: number, report: BrushMapReportType) {
    const { brushesFirm, teeth, firstGroupColors, secondGroupColors } = report

    return this.axiosCall({
      method: 'patch',
      url: '/api/web/admin/brush-maps/',
      data: {
        id: reportId,
        date_at: new Date(),
        brushesFirm: brushesFirm,
        teeth: teeth,
        firstGroupColors: firstGroupColors,
        secondGroupColors: secondGroupColors,
      },
    })
  }

  public removeReport(reportId: number) {
    return this.axiosCall({
      method: 'delete',
      url: `/api/web/admin/brush-maps/`,
      params: {
        id: reportId,
      },
    })
  }
}

export const brushReportApi = new BrushReportApi({
  baseURL:
    process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URI : '',
  withCredentials: true,
})
